import React, {Component} from 'react';
import "./c75_professorship_list_item.scss";
import {Col, Container, Row} from "react-bootstrap";
import {TFunction} from "i18next";

export interface ProfessorshipItem {
    teaching: string;
    url: string;
    professors: string[];
    degree: string;
    channel?: string;
}

export function professorshipKey(professorship: ProfessorshipItem): string {
    return `${professorship.teaching}-${professorship.url}`;
}

interface ProfessorshipComponentData extends ProfessorshipItem {
    t: TFunction;
}

class ProfessorshipListItem extends Component<ProfessorshipComponentData> {

    render() {
        let key = professorshipKey(this.props);

        return (
                <Container key={"professorship-" + key} className="c75-professorship h-card">
                    <a href={this.props.url}>
                    <Row>
                        <Col className="p-name teaching" key={`professorship-teaching-${key}`}>
                            {this.props.teaching}
                            {this.props.channel &&
                                ` — ${this.props.t("C75 course channel")} ${this.props.channel}`
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col className="professors-col">
                            <p key="professors-label" className="label">{this.props.t("C75 professors label")}</p>
                            {this.props.professors && this.props.professors.map(professor => (
                                <p className="professor" key={`professor-${professor}`}>{professor}</p>
                            ))}
                        </Col>
                        <Col className="degree-col">
                            <p className="label">{this.props.t("C75 degree label")}</p>
                            <p className="degree">{this.props.degree}</p>
                        </Col>
                    </Row>
                    </a>
                </Container>
        );
    }
}

export default ProfessorshipListItem;
